module.exports = __webpack_public_path__ + "static/media/092-sierra-leone.822cf17a.svg";